import React from "react";

function About() {
  return (
    <div
      id="about"
      className="form-1"
      style={{ textAlign: "center", paddingTop: "40px" }}
    >
      <div style={{ width: "60%", margin: "auto" }}>
        <h2>About</h2>
        <p className="text-container">
          <strong>Our Motto </strong>- To accelerate our clients and the public to transform the data and
          knowledge into actionable insights that lead to value creation and
          societal impact. Re-inventing business strategy through data,
          strategy, design, and innovation.
          </p>
          <p className="text-container"> Our partners consist of Ph.D. and
          Master in the interdisciplinary background: Economics, Computer
          Science, Business Strategy, Engineering, Social Science, and many
          more. We all serve clients and the public consistently accelerating
          cutting-edge technology and humanity. Inspired by our chairman Dr.
          Harry Patria, we are constantly strengthening both capability
          development (learning and teaching) and project development (research
          and project) at our clients and public MasterClass.
        </p>
      </div>
    </div>
  );
}

export default About;
